"use client";

import dynamic from "next/dynamic";

const PDFViewer = dynamic(() => import("@/components/PDFViewer"), {
  ssr: false,
  loading: () => (
    <div className="flex items-center justify-center min-h-125">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-school-navy mb-4"></div>
        <p className="text-gray-600">Loading Weekly Wrap-Up...</p>
      </div>
    </div>
  ),
});

interface PDFViewerWrapperProps {
  fileUrl?: string;
  fitToViewport?: boolean;
}

export default function PDFViewerWrapper({ fileUrl, fitToViewport = false }: PDFViewerWrapperProps) {
  if (!fileUrl) {
    return (
      <div className="flex items-center justify-center min-h-100">
        <p className="text-gray-500">No wrap-up PDF has been configured. Please set one in the admin panel.</p>
      </div>
    );
  }
  return <PDFViewer fileUrl={fileUrl} fitToViewport={fitToViewport} />;
}
